import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import ShopApp from '~/src/app/ShopApp'
import '~/src/app/styles/shop.css'

const mount = document.getElementById('shop-root')

if (mount) {
  createRoot(mount).render(
    <React.StrictMode>
      <BrowserRouter basename="/tienda">
        <ShopApp />
      </BrowserRouter>
    </React.StrictMode>
  )
}
